import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { convertedValue } from "../../../utils/common";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";

const statusOptions = [
  {
    label: "Pending",
    value: "PENDING",
  },
  {
    label: "Approved",
    value: "APPROVED",
  },
  {
    label: "Rejected",
    value: "REJECTED",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    userName: "",
    fullName: "",
    mobileNo: "",
    cafNumber: "",
    status: {},
  };

  const { payload, setPayload, setFilterResetFunc } = props;

  const [defaultStatus, setDefaultStatus] = useState([]);
  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => () => reset(initialValues));
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.userName != "" && data.userName != null) {
        filters.push({
          fieldName: "userName",
          fieldValue: data.userName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.fullName != "" && data.fullName != null) {
        filters.push({
          fieldName: "fullName",
          fieldValue: data.fullName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.mobileNo != "" && data.mobileNo != null) {
        filters.push({
          fieldName: "mobileNo",
          fieldValue: data.mobileNo,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.cafNumber != "" && data.cafNumber != null) {
        filters.push({
          fieldName: "cafNumber",
          fieldValue: data.cafNumber,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (
        data.status != null &&
        Object.keys(data.status).length != 0 &&
        data.status.value != undefined
      ) {
        filters.push({
          fieldName: "status",
          fieldValue: convertedValue(data.status, "value").join(","),
          op: "eq",
          dataType: "enum",
          condition: "and",
          isJoin: false,
        });
      }

      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={6} pt={4}>
            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("user_name", "User Name")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("full_name", "Full Name")}
                name="fullName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("mobile_number", "Mobile Number")}
                name="mobileNo"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("caf_number", "CAF Number")}
                name="cafNumber"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <SearchableAutoComplete
                control={control}
                data={statusOptions}
                label={t("status", "Status")}
                payload={null}
                setPayload={null}
                loading={false}
                name="status"
                multiple={false}
                defaultValue={defaultStatus}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={() => reset(initialValues)} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
